import { render, staticRenderFns } from "./PrintHelp.vue?vue&type=template&id=6b5b2c52&"
import script from "./PrintHelp.vue?vue&type=script&lang=ts&"
export * from "./PrintHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5b2c52')) {
      api.createRecord('6b5b2c52', component.options)
    } else {
      api.reload('6b5b2c52', component.options)
    }
    module.hot.accept("./PrintHelp.vue?vue&type=template&id=6b5b2c52&", function () {
      api.rerender('6b5b2c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/PrintHelp.vue"
export default component.exports